//This is for listing all CURRENT leagues

import React, { useEffect, useState } from 'react'
import './AdminLeagueList.css'
import AdminNavigation from './AdminNavigation'
import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import { NavLink } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminCurrentLeagueList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [leagueId, setLeagueId] = useState('')
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [showConfirmArchiveModal, setShowConfirmArchiveModal] = useState(false)
	const [leagueDeleted, setLeagueDeleted] = useState()
	const [leagueArchived, setLeagueArchived] = useState()
	const [leagueToDelete, setLeagueToDelete] = useState()
	const [loadedCurrentLeagues, setLoadedCurrentLeagues] = useState()

	//Let's get a list of all current leagues
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setLeagueDeleted(false)
			setLeagueArchived(false)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log(responseData)

				setLoadedCurrentLeagues(responseData.currentLeagues)
				setIsLoading(false)
			} catch (err) {
				setError('ERROR: ' + err.message)
			}
			setLeagueArchived(false)
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedCurrentLeagues, leagueDeleted, leagueArchived])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Delete warning
	//
	//******************************************************** */

	const showDeleteWarningHandler = (e, leaguename) => {
		const value = e.target.id
		console.log('league to delete: ' + leaguename)
		setLeagueToDelete(leaguename)
		setLeagueId(loadedCurrentLeagues[value]._id)
		setShowConfirmModal(true)
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}

	//console.log('league right here: ' + leagueId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/removeLeague`,
				'DELETE'
			)
		} catch (err) {}
		setLeagueDeleted(true)
	}
	//******************************************************** */
	//
	//     Archive warning
	//
	//******************************************************** */
	const showArchiveWarningHandler = (e) => {
		const value = e.target.id
		setLeagueId(loadedCurrentLeagues[value]._id)
		setShowConfirmArchiveModal(true)
	}

	const cancelArchiveHandler = () => {
		setShowConfirmArchiveModal(false)
	}

	const confirmArchiveHandler = async () => {
		setShowConfirmArchiveModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/archiveCurrentToggleLeague`,
				'PATCH'
			)
		} catch (err) {}
		setLeagueArchived(true)
	}
	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete <h1>{leagueToDelete}</h1>
						</p>
						<p className='modalText'>
							This will also delete all the teams and players within that
							tournament.
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE LEAGUE
						</button>
					</React.Fragment>
				}
			></Modal>
			<Modal
				show={showConfirmArchiveModal}
				onCancel={cancelArchiveHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to archive this tournament?
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelArchiveHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							danger
							onClick={confirmArchiveHandler}
						>
							ARCHIVE TOURNAMENT
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && !loadedCurrentLeagues && (
				<div className='AdminLeagues'>
					<AdminNavigation />
					<h1>No Current Tournaments Found!</h1>
					<div className='row'>
						<NavLink
							to={`/admin/league/new`}
							exact
							className='centeredButtonSmallMargin'
							style={{ display: 'block', width: 'auto', fontWeight: '700' }}
						>
							Create a New Tournament
						</NavLink>
					</div>
					<h5>OR</h5>
					<div className='row'>
						<NavLink
							to={`/admin/leagues/archive`}
							exact
							className='centeredButtonSmallMargin'
							style={{ display: 'block', width: 'auto', fontWeight: '700' }}
						>
							View Archived Tournaments
						</NavLink>
					</div>
				</div>
			)}
			{!isLoading && loadedCurrentLeagues && (
				<div className='AdminLeagues'>
					<AdminNavigation />
					<h1>Tournaments</h1>
					<div className='row'>
						<NavLink
							to={`/admin/league/new`}
							exact
							className='centeredButtonSmallMargin'
							style={{ display: 'block', width: 'auto', fontWeight: '700' }}
						>
							Create a New Tournament
						</NavLink>
					</div>
					<h5>OR</h5>
					<div className='row'>
						<NavLink
							to={`/admin/leagues/archive`}
							exact
							className='centeredButtonSmallMargin'
							style={{ display: 'block', width: 'auto', fontWeight: '700' }}
						>
							View Archived Tournaments
						</NavLink>
					</div>
					<table id='leagues'>
						<thead>
							<tr>
								<th>Tournament Name</th>
								<th>Year</th>
								<th>Divisions</th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedCurrentLeagues.map((league, key) => {
								return (
									<tr key={key}>
										<td>{league.leagueName}</td>
										{/* <td>{league.divisionName && league.divisionName}</td>
										<td>{league.session}</td> */}
										<td>{league.year}</td>
										<td>{league.numberOfDivisions}</td>
										{/* {league.divisionName && (
											<td>
												<NavLink
													className='navlinks'
													to={`/admin/${league.leagueName}/${league.divisionName}/${league.session}/${league.year}/teams`}
													exact
												>
													Teams
												</NavLink>
											</td>
										)} */}
										{!league.divisionName && (
											<td>
												<NavLink
													className='navlinks'
													to={`/admin/${league.leagueName}/${league.year}/divisions`}
													exact
												>
													Divisions
												</NavLink>
											</td>
										)}
										<td>
											{/* These buttons used to be NavLinks.  But I changed them to look better */}
											<NavLink
												className='navlinks'
												to={`/admin/updateLeague/${league._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												id={key}
												onClick={(e) => showArchiveWarningHandler(e)}
											>
												Archive
											</button>
										</td>
										<td>
											<button
												className='buttonButton'
												style={{ color: 'red' }}
												id={key}
												onClick={(e) =>
													showDeleteWarningHandler(e, league.leagueName)
												}
											>
												DELETE
											</button>
										</td>
									</tr>
								)
							})}
							<tr style={{ backgroundColor: '#e0e0e0' }}>
								<td>
									<AdminButton
										to={`/admin/league/new`}
										exact
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
									>
										Add New Tournament
									</AdminButton>
								</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminCurrentLeagueList
